import React from "react";
import BorderBody from "./border-body.jsx";
import BorderTh from "./border-th.jsx";
import BorderTd from "./border-td.jsx";

const _BorderTable = ({children, className, mergeTable = false}) => {
    return (
        <div className={[`overflow-hidden rounded border border-[#f6f6f6] ${mergeTable ? "flex flex-col divide-y divide-[#f6f6f6]" : ""}`, className].join(" ")}>
            {children}
        </div>
    );
};

export const BorderTable = Object.assign(_BorderTable, {
    Table: BorderBody,
    Th: BorderTh,
    Td: BorderTd,
});
